import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useBreadcrumbsData } from '../contexts/BreadcrumbsData';

export const useBreadcrumbs = (breadcrumbs) => {
  const { t } = useTranslation();
  const { setBreadcrumbData } = useBreadcrumbsData();

  useEffect(() => {
    setBreadcrumbData(breadcrumbs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [t]);
};
